import script from "./IconLightning.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconLightning.vue?vue&type=script&setup=true&lang=ts"

import "./IconLightning.vue?vue&type=style&index=0&id=dbf528b2&scoped=true&lang=css"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbf528b2"]])

export default __exports__